import { BrowserRouter } from 'react-router-dom'
import { AuthGuard } from './auth/AuthGuard'
import { AppRouter } from './router'
import { ToastContainer } from './components/ui/Toast'

export default function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <AppRouter />
      </AuthGuard>
      <ToastContainer />
    </BrowserRouter>
  )
}
